import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { 
  Menu as MenuIcon, 
  MenuOpen as MenuOpenIcon,
  ChevronLeft as CollapseIcon,
  ChevronRight as ExpandIcon
} from "@mui/icons-material";

interface NavToggleProps {
  expanded?: boolean;
  onChange?: () => void;
  isVisible?: boolean;
}

const SidebarNavToggle = ({ expanded, onChange, isVisible }: NavToggleProps) => {
  return (
    <Tooltip title={expanded ? "Collapse Sidebar" : "Expand Sidebar"}>
      <IconButton
        onClick={onChange}
        className={`sidebar-toggle-btn ${expanded ? 'expanded' : 'collapsed'}`}
        size="large"
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          color: '#2d3748',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            transform: 'scale(1.05)',
            boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
          },
          '&.expanded': {
            left: '280px',
          },
          '&.collapsed': {
            left: '20px',
          },
        }}
      >
        {expanded ? <CollapseIcon /> : <ExpandIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default SidebarNavToggle;
